"use client";

import {
  AlertTriangle,
  Badge,
  BadgeCheck,
  Ban,
  CalendarCheck,
  Dog,
  MessageCircle,
  PlaneTakeoff,
  RefreshCw,
  Search,
  Shield,
  Tv,
} from "lucide-react";

import { Tabs, TabsContent } from "@repo/ui/components/ui/tabs";
import type { LinkedItem } from "@repo/ui/types/cms/common";

import HeaderLayout from "../HeaderLayout";
import DesktopLayout from "./DesktopLayout";
import { InfoTabSwitcher } from "./InfoTabSwitcher";
import MobileLayout from "./MobileLayout";
import type { TravelInfoSection } from "./type";

const travelInfoSections: TravelInfoSection[] = [
  {
    title: "Prepara tu viaje",
    items: [
      { icon: <PlaneTakeoff size={16} />, label: "Pack SMART" },
      { icon: <Tv size={16} />, label: "Entretenimiento a bordo" },
      { icon: <BadgeCheck size={16} />, label: "Vuelo con escala" },
      { icon: <Dog size={16} />, label: "Mascotas a bordo" },
      { icon: <Badge size={16} />, label: "Equipaje" },
      { icon: <BadgeCheck size={16} />, label: "Opcionales" },
    ],
  },
  {
    title: "Tu viaje",
    items: [
      { icon: <CalendarCheck size={16} />, label: "Administra tu vuelo" },
      { icon: <Shield size={16} />, label: "Requisitos de entrada" },
      { icon: <Ban size={16} />, label: "Artículos prohibidos" },
      { icon: <Search size={16} />, label: "Check-in" },
      { icon: <BadgeCheck size={16} />, label: "Estado de vuelo" },
    ],
  },
  {
    title: "Post vuelo",
    items: [
      { icon: <MessageCircle size={16} />, label: "Contáctanos" },
      { icon: <RefreshCw size={16} />, label: "Cambios y devoluciones" },
      { icon: <AlertTriangle size={16} />, label: "Vuelos afectados" },
    ],
  },
];

interface TabContentProps {
  linkedItem: LinkedItem;
}

const TabContent = ({ linkedItem }: Readonly<TabContentProps>) => (
  <>
    <DesktopLayout item={linkedItem} />
    <MobileLayout travelInfoSections={travelInfoSections} />
  </>
);

interface ProfileProps {
  linkedItems?: LinkedItem[];
  title?: string;
  subtitle?: string;
}

// Main component
export default function Profile({ linkedItems }: Readonly<ProfileProps>) {
  return (
    <HeaderLayout>
      <Tabs
        defaultValue={linkedItems?.length && linkedItems[0]?.name ? linkedItems[0].name : ""}
        className="w-full"
        data-testid="profile-tabs"
      >
        <InfoTabSwitcher linkedItems={linkedItems} />

        {linkedItems?.length &&
          linkedItems.map((linkedItem) => (
            <TabsContent
              key={linkedItem.name}
              value={linkedItem.name || ""}
              data-testid={`profile-tab-content-${linkedItem.name}`}
            >
              <TabContent linkedItem={linkedItem} />
            </TabsContent>
          ))}
      </Tabs>
    </HeaderLayout>
  );
}
